export const API_PARCEL_FIND_ROUTE = '/api/parcel';
